import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, EnumDecoder, field, StringDecoder } from "@simonbackx/simple-encoding";
import { Address } from "./Address";
import { Cart } from "./Cart";
import { CheckoutCode } from "./CheckoutCode";
import { Business, ContactPerson } from "./Customer";
import { OrderPrices } from "./OrderPrices";
import { OrderType } from "./OrderType";
import { PaymentMethod } from "./PaymentMethod";
export class Checkout extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.cart = Cart.create({});
        this.business = null;
        this.contactPerson = null;
        this.type = OrderType.Delivery;
        /**
         * Date when a delivery-type order needs to be delivered to the customer
         */
        this.deliveryDate = null;
        /**
         * Date when a delivery-type order needs to be picked up from the customer
         */
        this.retrievalDate = null;
        /**
         * Date when a pickup-type order will be picked up by the customer
         */
        this.pickupDate = null;
        /**
         * Date when a pickup-type order will be returned by the customer
         */
        this.returnDate = null;
        this.deliveryAddress = null;
        /**
         * @deprecated from version >= 7. Moved to `notes` field.
         */
        this.deliveryNotes = "";
        this.notes = "";
        this.paymentMethod = null;
        this.code = null;
    }
    get VATPercentage() {
        return 21;
    }
    get calculatedPrices() {
        // Note: due to a possible bug in simple-encoding, existing orders before the addition of the `code` field,
        // will have `undefined` as the value of said field, completely ignoring the configured default value of `null`.
        const deliveryCost = (this.code === null || this.code === undefined)
            ? this.cart.getDeliveryCost(this.type)
            : this.code.amount;
        return OrderPrices.create({
            deliveryCost,
            warranty: this.cart.warranty,
            cartPrice: this.cart.price,
            VAT: Math.round((deliveryCost + this.cart.price) * (this.VATPercentage) / 100) // NO VAT on warranty!
        });
    }
}
__decorate([
    field({ decoder: Cart })
], Checkout.prototype, "cart", void 0);
__decorate([
    field({ decoder: Business, nullable: true })
], Checkout.prototype, "business", void 0);
__decorate([
    field({ decoder: ContactPerson, nullable: true })
], Checkout.prototype, "contactPerson", void 0);
__decorate([
    field({ decoder: new EnumDecoder(OrderType), optional: true })
], Checkout.prototype, "type", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Checkout.prototype, "deliveryDate", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true, version: 7, upgrade: function () {
            return this.pickupDate;
        } })
], Checkout.prototype, "retrievalDate", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Checkout.prototype, "pickupDate", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true, optional: true })
], Checkout.prototype, "returnDate", void 0);
__decorate([
    field({ decoder: Address, nullable: true })
], Checkout.prototype, "deliveryAddress", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Checkout.prototype, "deliveryNotes", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 7, upgrade: function () {
            return this.deliveryNotes;
        } })
], Checkout.prototype, "notes", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PaymentMethod), nullable: true })
], Checkout.prototype, "paymentMethod", void 0);
__decorate([
    field({ decoder: CheckoutCode, nullable: true, optional: true })
], Checkout.prototype, "code", void 0);
//# sourceMappingURL=Checkout.js.map